/* global navigator, fetch */
/**
 * TananTech API Service
 * Handles data submission to TananTech datastore endpoint
 */

const TANANTECH_API_BASE_URL = 'https://datastore.tanantech.co.uk/1.0';
const DATA_ENDPOINT = `${TANANTECH_API_BASE_URL}/data`;

/**
 * Submit form data to TananTech API
 * @param {Object} formData - The form data to submit
 * @param {string} webFormId - Unique identifier for the form
 * @returns {Promise<Object>} - Response containing dataid
 */
export const submitFormData = async (formData, webFormId) => {
  try {
    // Prepare the data payload with required web_form_id
    const payload = {
      web_form_id: webFormId,
      ...formData,
      submitted_at: new Date().toISOString(),
      user_agent: navigator.userAgent,
      page_url: window.location.href
    };

    const response = await fetch(DATA_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    
    // Validate that we received a dataid
    if (!result.dataid) {
      throw new Error('Invalid response: missing dataid');
    }

    return {
      success: true,
      dataid: result.dataid,
      message: 'Form submitted successfully'
    };

  } catch (error) {
    console.error('TananTech API Error:', error);
    
    return {
      success: false,
      error: error.message,
      message: 'Failed to submit form. Please try again.'
    };
  }
};

/**
 * Validate web_form_id format
 * @param {string} webFormId - The web form ID to validate
 * @returns {boolean} - True if valid format
 */
export const validateWebFormId = (webFormId) => {
  // Must be lowercase letters, numbers, and underscores only
  const validPattern = /^[a-z0-9_]+$/;
  return validPattern.test(webFormId);
};